<template>
  <div class="points mb-5">
    <HeroKeyValue>
      <template #k>{{ $tt('page.hero_price') }}</template>
      <template #v>
        <FromPrice :price="product.price" />
      </template>
    </HeroKeyValue>
    <HeroKeyValue :k="$tt('page.hero_processing')" :v="tWaitDays(product.country)" />
    <HeroKeyValue :k="$tt('page.product_features.validity')" :v="tValidityRange(product.country)" />
  </div>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  product: Product;
}>();

const { tWaitDays, tValidityRange } = useLocalization();
</script>

<style scoped>
.points {
  display: grid;
  gap: var(--space-8);
  grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 600px) {
  .points {
    gap: var(--space-5);
  }
}
</style>